import AGREGAR_CATALOGO_INSUMO from '@/graphql/mutations/administracion/catalogos/insumos/agregarCatalogoInsumo.gql';
import ACTUALIZAR_CATALOGO_INSUMO from '@/graphql/mutations/administracion/catalogos/insumos/actualizarCatalogoInsumo.gql';
import REMOVER_CATALOGO_INSUMO from '@/graphql/mutations/administracion/catalogos/insumos/removerCatalogoInsumo.gql';
import CATALOGO_INSUMOS from '@/graphql/querys/administracion/catalogos/insumos/catalogoInsumos.gql';

export default {
  methods: {
    // AGREGAR CATALOGO INSUMO
    async mixAgregarCatalogoInsumo() {
      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: AGREGAR_CATALOGO_INSUMO,
          variables: {
            insumo: this.insumo,
          },
          update: (store, { data: { agregarCatalogoInsumo } }) => {
            const query = {
              query: CATALOGO_INSUMOS,
            };
            const { catalogoInsumos } = store.readQuery(query);
            const catalogoInsumosCopia = catalogoInsumos.slice();
            catalogoInsumosCopia.push(agregarCatalogoInsumo);
            store.writeQuery({
              ...query,
              data: {
                catalogoInsumos: catalogoInsumosCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.mixEsCargando();
      this.enviandoFormulario = false;
      this.cerrar();
    },

    // ACTUALIZAR CATALOGO INSUMO
    async mixActualizarCatalogoInsumo() {
      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_CATALOGO_INSUMO,
          variables: {
            id: this.insumoEditar.id,
            insumo: this.insumo,
          },
          update: (store, { data: { actualizarCatalogoInsumo } }) => {
            const query = {
              query: CATALOGO_INSUMOS,
            };
            const { catalogoInsumos } = store.readQuery(query);
            const index = catalogoInsumos
              .findIndex(({ id }) => id === this.insumoEditar.id);
            if (index !== -1) {
              catalogoInsumos.splice(index, 1, actualizarCatalogoInsumo);
            }
            store.writeQuery({
              ...query,
              data: {
                catalogoInsumos,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.mixEsCargando();
      this.enviandoFormulario = false;
      this.cerrar();
    },

    // ELIMINAR CATALOGO INSUMO
    async mixEliminarCatalogoInsumo() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_CATALOGO_INSUMO,
        variables: {
          id: this.insumoEliminar.id,
        },
        update: (store) => {
          const query = {
            query: CATALOGO_INSUMOS,
          };
          const data = store.readQuery(query);
          const { catalogoInsumos } = data;
          const index = catalogoInsumos
            .findIndex(({ id }) => id === this.insumoEliminar.id);
          if (index !== -1) {
            catalogoInsumos.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
